
import ATMTextField from 'src/components/UI/atoms/formFields/ATMTextField/ATMTextField'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { CircularProgress } from '@mui/material';

// |-- Types --|
type Props = {
    listHeading: string
    onAddClick: () => void
    listData: any[]
    searchValue?: string
    OnSearchChange?: (newValue: string) => void
    disabled: boolean
    featureIsLoading?: any
}

const ChapterListLayout = ({
    listHeading,
    onAddClick,
    listData,
    searchValue = '',
    OnSearchChange = (newValue: string) => { },
    disabled = false,
    featureIsLoading = false,
}: Props) => { 
 
     //Naviagtions 
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
     //Get Chapter Id 
     const chapterId = queryParams.get("chapterId");
      //Get Module Id 
    const {moduleId} = useParams()
    return (
        <div className="border h-full w-full flex flex-col gap-1 rounded bg-white shadow-lg ">
            <div className="border-b  text-slate-600 px-2 text-lg h-[50px] flex items-center justify-between font-semibold ">
                {listHeading}

                <button
                    type="button"
                    disabled={disabled}
                    className="flex items-center gap-2 text-primary-main  text-sm h-[33px] px-4 rounded hover:bg-slate-100"
                    onClick={() => {
                        onAddClick()
                    }}
                >
                    {' '}
                    + Add{' '}
                </button>


            </div>

            <div className="px-2 border-b">
                <ATMTextField
                    name=""
                    value={searchValue}
                    onChange={(e) => {
                        OnSearchChange(e.target.value)
                    }}
                    placeholder="Search"
                    className="h-[30px] border-none"
                />
            </div>

            <div className="max-h-[calc(100%-100px)]  overflow-hidden hover:overflow-auto">
                {featureIsLoading ? (
                    <div className="flex justify-center items-center h-[400px]">
                        <CircularProgress />{" "}
                    </div>
                ) : listData?.length ? (
                    <>
                        {listData?.map((listItem, listItemIndex) => {

                            if (searchValue) {
                                return (listItem?.chapterName?.toLowerCase()?.includes(searchValue?.toLowerCase()) ?
                                    //  On search Item
                                    <div
                                        key={listItemIndex}
                                        onClick={() => {
                                            navigate(`/configuration/modules-chapter/${moduleId}?chapterId=${listItem?._id}`);
                                        }}
                                        className={`border-b border-slate-100 py-1 px-2 text-black-500 cursor-pointer text-sm capitalize ${listItem._id !== undefined &&
                                            (chapterId ===
                                                listItem._id
                                            )
                                            ? 'bg-gray-300'
                                            : ''
                                            }`}
                                    >
                                        {listItem.chapterName}
                                    </div>

                                    : null)
                            } else {
                                return (
                                    <div
                                        key={listItemIndex}
                                        onClick={() => {
                                            navigate(`/configuration/modules-chapter/${moduleId}?chapterId=${listItem?._id}`)
                                        }}
                                        className={`border-b border-slate-100 py-1 px-2 text-black-500 cursor-pointer text-sm capitalize ${listItem._id !== undefined &&
                                            (chapterId ===
                                                listItem._id
                                            )
                                            ? 'bg-gray-300'
                                            : ''
                                            }`}
                                    >
                                        {listItem.chapterName}
                                    </div>

                                )
                            }

                        })}
                    </>
                ) :
                    (<div className='p-2 m-5 font-bold text-slate-400'> NO DATA FOUND </div>)
                }
            </div>
        </div>
    )
}

export default ChapterListLayout
